import React from "react";
import { Link } from "react-router-dom";
import LogoutPage from './Logout';
// import profile from "../../../images/profile/17.jpg";
import { Dropdown } from "react-bootstrap";

const Header = () => {
	const TokenDetails = JSON.parse(localStorage.getItem('organizerName'));
  return (
    <div className="header">
		<div className="header-content">
			<nav className="navbar navbar-expand">
				<div className="collapse navbar-collapse justify-content-between">
					<div className="header-left"></div>
					<ul className="navbar-nav header-right">						
						<Dropdown as="li" className="nav-item header-profile ">
							<Dropdown.Toggle as="a" to="#" variant="" className="nav-link i-false c-pointer">
								<div className="header-info">
									<span className="text-black">Hello, <strong>{TokenDetails}</strong></span>
									<p className="fs-13 mb-0">Organizer</p>
								</div>
								<i className="fa fa-caret-down" style={{height:"40px"}}> </i>
							</Dropdown.Toggle>
							<Dropdown.Menu align="end" className="mt-2">
							  <Link to="/organizer-profile" className="dropdown-item ai-icon">
								<span className="ms-2">Profile </span>
							  </Link>
							  <Link to="/change-password" className="dropdown-item ai-icon">
								<span className="ms-2">Change Password </span>
							  </Link>
							  <LogoutPage />
							</Dropdown.Menu>
						</Dropdown>
					</ul>
				</div>
			</nav>
		</div>
    </div>
  );
};

export default Header;
